module.exports = __webpack_public_path__ + "static/media/mmm-icon-parking.3cbdcc01.svg";